angular.module('Filters')
.filter('formatStatus', function(){
    return function (input) {

        try {
            //split camelCase status into words
            var words = input.match(/([A-Z]?[^A-Z]*)/g).slice(0,-1);

            // capitalize first letter of first word
            words[0] = words[0].charAt(0).toUpperCase() + words[0].substr(1);

            var formattedStatus = words.join(' ');

            return formattedStatus;
        } catch (e) {
            console.error(e);
            return input;
        }

        
    };
});